export default __webpack_public_path__ + "static/media/splunk-on-call-logo.54113d88.svg";